export const GET_BUSINESSES = gql`
    query GetBusinesses {
        businesses {
            id
            hierarchyLevel
            legalName
            partnerId
            partnerOfPartnerId
            merchantId
            partner {
                country
                countryDetails {
                    alpha2Code
                }
            }
            partnerOfPartner {
                country
                countryDetails {
                    alpha2Code
                }
            }
        }
    }
`;
